import React from 'react';
import { View, Text, StyleSheet, ViewStyle } from 'react-native';
import { useTheme, TYPOGRAPHY } from '../../theme';

interface DotLabelProps {
  label: string;
  variant?: 'progress' | 'risk' | 'news' | 'partial' | 'primary' | 'muted';
  style?: ViewStyle;
  testID?: string;
}

/**
 * Tiny colored dot + 11px semibold word — the Plaud-grammar replacement for
 * Badge chips. Category and status render as dot-labels ("Progress",
 * "Claimed", "Unverified"); the word takes the semantic color, the dot takes
 * currentColor. Use `muted` for non-semantic statuses.
 */
export function DotLabel({ label, variant = 'muted', style, testID }: DotLabelProps) {
  const { colors } = useTheme();

  const color = {
    progress: colors.progress,
    // The 'risk' variant is the post CATEGORY (displayed "Opportunity",
    // blue since Aug 2026) — every call site is a category chip, never
    // structure readiness, which has its own color path (readiness.ts).
    risk: colors.opportunity,
    news: colors.news,
    partial: colors.partial,
    primary: colors.primary,
    muted: colors.textSecondary,
  }[variant];

  return (
    <View style={[styles.container, style]} testID={testID}>
      <View style={[styles.dot, { backgroundColor: color }]} />
      <Text style={[styles.label, { color }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    alignSelf: 'flex-start',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  label: {
    ...TYPOGRAPHY.metadata,
    fontFamily: TYPOGRAPHY.h4.fontFamily, // semibold at the metadata size
  },
});
